// react_frontend/src/Components/Modules/Payment.js
import React, { useState } from "react";
import axios from "axios";
import Constant from "../../Constant";
import { useNavigate, useLocation } from "react-router-dom";
import { FaCreditCard, FaPaypal, FaStripe } from "react-icons/fa";

const Payment = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const email = localStorage.getItem("pendingEmail") || "user@example.com";

  const handlePayment = async (method) => {
    setIsProcessing(true);
    setError("");

    await new Promise((r) => setTimeout(r, 2000));

    try {
      const res = await axios.post(
        `${Constant.BASE_URL}/confirm-payment`,
        { email },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      alert("Payment successful!\nYour license key: " + res.data.license_key);
      navigate("/");
    } catch (err) {
      setError("Payment failed. Please try again.");
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
        <h4 className="text-center mb-4">Complete Payment</h4>
        <p>
          <strong>Email:</strong> {email}
        </p>
        <p>
          <strong>Amount:</strong> $49.99/year
        </p>

        {error && <div className="alert alert-danger">{error}</div>}

        <div className="d-grid gap-3 mt-4">
          <button
            className="btn btn-success d-flex align-items-center justify-content-center"
            onClick={() => handlePayment("card")}
            disabled={isProcessing}
          >
            <FaCreditCard className="me-2" /> {isProcessing ? "Processing..." : "Pay with Card"}
          </button>

          <button
            className="btn btn-primary d-flex align-items-center justify-content-center"
            onClick={() => handlePayment("paypal")}
            disabled={isProcessing}
          >
            <FaPaypal className="me-2" /> Pay with PayPal
          </button>

          <button
            className="btn btn-indigo d-flex align-items-center justify-content-center"
            onClick={() => handlePayment("stripe")}
            disabled={isProcessing}
          >
            <FaStripe className="me-2" /> Pay with Stripe
          
          </button>
        </div>

        <small className="text-muted mt-3 text-center">
          This is a dummy payment system for development.
        </small>
      </div>
    </div>
  );
};

export default Payment;